import React, { useEffect } from 'react'
import Dropdown from '../../../../Components/Dropdown/Dropdown';
import Stepper from '../../../../Components/Stepper/Stepper';
import { Button, Input, Textarea } from '../../../../Components/StyledComponents';
import './CreateOptionGroup.scss';
import {cloneDeep} from 'lodash-es';

const ModifyOptionGroup = ({info,patchOptionGroup}) => {
    const [ step, setStep ] = React.useState(1)
    const [ name, setName ] = React.useState('')
    const [ desc, setDesc ] = React.useState('')
    const [ options, setOptions ] = React.useState([{ Name : '', Price : 0 , Description : '' }])
    const [ isRequire, setIsRequire ] = React.useState(true)
    const [ selectableCount, setSelectableCount ] = React.useState({ Min : 1, Max : 1 })

    useEffect(() => {
        setName(cloneDeep(info.Name));
        setDesc(cloneDeep(info.Description));
        setOptions(cloneDeep(info.OptionInfo));
        setIsRequire(cloneDeep(info.isRequire));
        setSelectableCount(cloneDeep(info.SelectableCount))
    },[])

    useEffect(() => {
        let arr = selectableCount;
        if( isRequire ) arr.Min = 1;
        else arr.Min = 0
        setSelectableCount(arr)
    },[isRequire])

    const nextStep = () => {
        if(step !== 3) setStep(old => old+1)
        else patch()
    }

    const getOptions = () => {
        let arr = []

        for(let i=0; i<info.OptionIds.length; i++){
            arr.push({ key : i+1 + '개', value : i+1 })
        }

        return arr;
    }

    const patch = () => {
        let arr = [];
        for(let i=0; i<options.length;i++){
            arr.push({ Name : options[i].Name, Price : parseInt(options[i].Price), Description : options[i].Description })
        }
        patchOptionGroup({
            GroupId : info._id.$oid,
            Name : name,
            Description : desc,
            isRequire : isRequire,
            SelectableCount : {
                Min : parseInt(selectableCount.Min),
                Max : parseInt(selectableCount.Max)
            }
        })
    }

    const isDisabled = () => {
        if(step === 1 && name.trim() === '' ) return true
        else if( step === 2 && ( options.length === 0 || options[0].Name.trim() === '' )) return true
        else return false
    }


    return (
        <div className='create-option-group'>
            <Stepper maxStep={3} step={step} containerStyle={{ marginBottom : step === 3 ? 0 : 40 }}/>
            {
                step === 4 && <p className="warn-text">모두 입력되었어요. 마지막으로 확인해주세요.</p>
            }
            {
                step === 1 &&
                <>
                    <div className='row'>
                        <p className='label'>옵션그룹명</p>
                        <Input
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            style={{ width : 347 }}
                            placeholder="예) 맛선택, 사이드메뉴 추가 등"
                        />
                    </div>

                    <div className='row' style={{ alignItems : 'flex-start', marginTop : 16 }}>
                        <p className='label'>설명(선택)</p>
                        <Textarea
                            value={desc}
                            onChange={(e) => setDesc(e.target.value)}
                            style={{ width : 347, height : 173 }}
                            placeholder="예) 추가 옵션입니다 (1개 이상 필수)"
                        />
                    </div>
                </>
            }

            {
                step === 2 &&
                <>
                    <p className='label'>옵션정보</p>
                    <div className='row' style={{ marginTop : 16 }}>
                        <button className={`${ isRequire ? 'selected-btn' : 'unselected-btn'}`} style={{ marginRight : 32, width : 180 }} onClick={() => setIsRequire(true)}>
                            <div className='row' style={{ justifyContent : 'center' }}>
                                {
                                    isRequire ?
                                    <img src={require('../../../../aseets/icons/check.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                                    :
                                    <img src={require('../../../../aseets/icons/check_white.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                                }
                                옵션 선택시 주문가능
                            </div>
                        </button>

                        <button className={`${ !isRequire ? 'selected-btn' : 'unselected-btn'}`} style={{ width : 232 }} onClick={() => setIsRequire(false)}>
                            <div className='row' style={{ justifyContent : 'center' }}>
                                {
                                    isRequire ?
                                    <img src={require('../../../../aseets/icons/close.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                                    :
                                    <img src={require('../../../../aseets/icons/close_white.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                                }
                                옵션 선택하지 않아도 주문가능
                            </div>
                        </button>
                    </div>

                    <p className='label' style={{ marginTop : 40 }}>옵션 개수</p>
                    <p className='label' style={{ marginTop : 8, marginBottom : 16, opacity : 0.5, width : 'fit-content' }}>현재 옵션 그룹에는 {options.length}개의 옵션이 있어요.</p>
                    <div className='row'>
                        {
                            isRequire &&
                            <>
                                <p className='drop-text'>최소</p>
                                <Dropdown
                                    width={161}
                                    options={getOptions()}
                                    onItemClick={(val) => setSelectableCount({...selectableCount, Min : val})}
                                    selected={true}
                                    value={selectableCount.Min}
                                    btnStyle={{ marginRight : 16 }}
                                    prefix={'개'}
                                />
                            </>
                        }
                        <p className='drop-text'>최대</p>
                        <Dropdown
                            width={isRequire ? 161:379}
                            options={getOptions()}
                            onItemClick={(val) => setSelectableCount({...selectableCount, Max : val})}
                            selected={true}
                            value={selectableCount.Max}
                            prefix={'개'}
                        />
                    </div>
                </>
            }
            
            {
                step === 3 &&
                <>
                    <p className="label" style={{ marginTop : 16 }}>옵션 그룹명</p>
                    <p className="text">{name}</p>
                    <div className="divider" style={{ margin : 0 }} />

                    <p className="label" style={{ marginTop : 16 }}>설명</p>
                    {
                        desc === '' ?
                        <p className="text-none">등록된 내용이 없어요.</p>
                        :
                        <p className="text">{desc}</p>
                    }
                    <div className="divider" style={{ margin : 0 }} />

                    <p className="label" style={{ marginTop : 16 }}>옵션 개수</p>
                    <p className="text">{isRequire ? `최소 ${selectableCount.Min}개 ` : ''} 최대 {selectableCount.Max}개</p>
                </>
            }
            

            <div className='btn-row'>
                {
                    step !== 1 &&
                    <Button variant="outline" className='save-btn' fontSize={16} onClick={() => setStep(old => old -1)} style={{ marginRight : 24 }}>
                        이전
                    </Button>
                }
                <Button variant="main" className='save-btn' fontSize={16} onClick={() => nextStep()} disabled={isDisabled()}>
                    {step === 3 ? '수정하기' : '다음'}
                </Button>
            </div>
        </div>
    )
}

export default ModifyOptionGroup;